/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {HolidayFormComponent as ɵc} from './holiday-form/holiday-form.component';
export {HolidayComponent as ɵb} from './holiday.component';
export {declaration as ɵa} from './holiday.module';
export {HolidayRoutes as ɵd} from './holiday.routing';